import { createGlobalStyle } from "styled-components";
import "@fontsource/akaya-telivigala";
import "@fontsource/sora";
import WanderlustFont from '../styles/fonts/Wanderlust.ttf';
import WILDWORLD from '../styles/fonts/WILDWORLD.otf';
import rocketImage from '../assets/timeline_img.png'; // Ensure the path matches your project structure

const GlobalStyles = createGlobalStyle`
@font-face {
    font-family: 'WILD WORLD';
    src: url(${WILDWORLD}) format('opentype');
    font-weight: normal;
    font-style: normal;
}

html {
    scroll-behavior: smooth;
}

*, *::before, *::after {
    margin: 0;
    padding: 0;
}

body {
    font-family: 'WILD WORLD', cursive;
    overflow-x: hidden;
}

h1, h2, h3, h4, h5, h6, a {
    margin: 0;
    padding: 0;
    color: inherit;
    text-decoration: none;
}

// Custom scrollbar styles
::-webkit-scrollbar {
    width: 16px; // Adjust the width of the scrollbar here
}

::-webkit-scrollbar-track {
    background: #f0f0f0; // Adjust track color here
}

::-webkit-scrollbar-thumb {
    background-image: url(${rocketImage}); // Using the rocket image as the scrollbar thumb
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 8px; // Optional: if you want rounded corners
    background-color: #ccc; // Fallback background color
    border: 4px solid transparent; // Creates padding around the image
    background-clip: content-box;
}

// For Firefox
* {
    scrollbar-width: thin; // 'auto' or 'thin'
    scrollbar-color: #ccc #f0f0f0; // thumb and track color
}
`

export default GlobalStyles;
